﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'address-missing-modal',
    data: () => ({
        
    }),
    props: [],
    methods: {
        closeModal() {
            this.$store.dispatch('showAddressMissingModal', false)
            var element = document.getElementById("addresslookup");
            var alignWithTop = false;
            element.scrollIntoView(alignWithTop);
        },
    },
computed:
    Object.assign(
        mapState({
            show: state => state.offeringpage.alertModals.showAddressMissingModal
        }),
        {
            

        }
    ),
    mounted: function () {
        document.addEventListener("keydown", (e) => {
            if (e.keyCode === 27) {
                this.closeModal()
            }
        });

        document.addEventListener('click', (e) => {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if(target.classList && target.classList.length > 0 && target.classList[0] === 'ts-modal') {
                this.closeModal()
            }
        }, false);
    }
}
